<template>
    <v-card class="elevation-0 pa-0">
        <v-card-text class="pa-0">
            <!-- Card del contenitore standard -->
            <!-- <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" align="center" class="my-0 py-0">
            <v-card class="my-0 py-0" outlined style="max-width: 750px">
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  Contenitore Standard
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text class="my-0 py-0">
                <v-container>
                  <v-row>
                    <v-col cols="3" class="my-0 py-0">
                      <v-autocomplete
                        v-model="data.id_articolo_contenitore_standard"
                        :items="items_contenitori"
                        item-text="cod_articolo"
                        item-value="id_articolo"
                        label="Cod. Contenitore"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3" class="my-0 py-0">
                      <v-text-field
                        label="Q.tà Cont."
                        :min="0"
                        type="number"
                        v-model="data.qta_contenitore_standard"
                      />
                    </v-col>
                    <v-col cols="3" class="my-0 py-0">
                      <v-autocomplete
                        v-model="data.id_articolo_imballo_standard"
                        :items="items_imballi"
                        item-text="cod_articolo"
                        item-value="id_articolo"
                        label="Imballo"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3" class="my-0 py-0">
                      <v-text-field
                        label="Q.tà Imb."
                        :min="0"
                        type="number"
                        v-model="data.qta_imballo_standard"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container> -->

            <!-- <v-divider class="my-5"></v-divider> -->

            <v-data-table
                :headers="headers_contenitori_alternativi"
                :items="
                    items_contenitori_alternativi != null
                        ? items_contenitori_alternativi.filter(
                              (e) => e.validita == 1
                          )
                        : []
                "
                class="elevation-2"
                height="60vh"
                fixed-header
                :key="key_tabella"
            >
                <!-- Titolo della tabella -->
                <template v-slot:top>
                    <v-toolbar color="indigo" dense>
                        <v-toolbar-title class="white--text">
                            Packaging
                        </v-toolbar-title>
                        <v-spacer></v-spacer>

                        <!-- Bottone di aggiunta -->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="aggiungiContenitore"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon color="primary"> mdi-plus </v-icon>
                                </v-btn>
                            </template>
                            <span>Aggiungi Contenitore</span>
                        </v-tooltip>

                        <!-- Bottone di salvataggio -->
                        <v-tooltip bottom v-if="show_save_button === true">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="ml-5"
                                    @click="savePackaging"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon color="success">
                                        mdi-floppy
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Conferma</span>
                        </v-tooltip>

                        <v-spacer></v-spacer>

                        <!-- Bottone di uscita -->
                        <v-tooltip bottom v-if="show_exit_button === true">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="goBack"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon color="error">
                                        mdi-keyboard-backspace
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Chiudi</span>
                        </v-tooltip>
                    </v-toolbar>
                </template>
                <!-- Bottone di modifica del contenitore -->
                <template v-slot:[`item.modifica`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-5"
                                @click="modificaContenitore(item)"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="primary"> mdi-pencil </v-icon>
                            </v-btn>
                        </template>
                        <span>Modifica Contenitore</span>
                    </v-tooltip>
                </template>

                <!-- Colonna della Ragione Sociale -->
                <template v-slot:[`item.ragione_sociale`]="{ item }">
                    {{
                        item.ragione_sociale == null ||
                        item.ragione_sociale == ""
                            ? item.ragione_sociale_c
                            : item.ragione_sociale
                    }}
                </template>

                <!-- Icona di modifica del parametro predefinito -->
                <template v-slot:[`item.predefinito`]="{ item }">
                    <v-icon
                        @click="setContAltStandard(item, 'predefinito')"
                        :color="item.predefinito === 1 ? 'success' : ''"
                        >{{
                            item.predefinito === 1
                                ? "mdi-checkbox-marked"
                                : "mdi-checkbox-blank-outline"
                        }}
                    </v-icon>
                </template>

                <!-- Icona di modifica del parametro predefinito per cliente -->
                <template v-slot:[`item.predefinito_per_cliente`]="{ item }">
                    <v-icon
                        @click="
                            setContAltStandard(item, 'predefinito_per_cliente')
                        "
                        :color="
                            item.predefinito_per_cliente === 1 ? 'success' : ''
                        "
                        >{{
                            item.predefinito_per_cliente === 1
                                ? "mdi-checkbox-marked"
                                : "mdi-checkbox-blank-outline"
                        }}
                    </v-icon>
                </template>

                <!-- Icona di modifica del parametro selected_for_commessa -->
                <template v-slot:[`item.selected_for_commessa`]="{ item }">
                    <v-icon
                        @click="setContAltCommessa(item)"
                        :color="
                            item.selected_for_commessa === 1 ? 'success' : ''
                        "
                        >{{
                            item.selected_for_commessa === 1
                                ? "mdi-checkbox-marked"
                                : "mdi-checkbox-blank-outline"
                        }}
                    </v-icon>
                </template>

                <!-- Bottone di eliminazione del contenitore -->
                <template v-slot:[`item.elimina`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-5"
                                @click="clickEliminaContenitore(item)"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Elimina Contenitore</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-card-text>

        <!-- Dialog della modifica / aggiunta del packaging selezionato -->
        <v-dialog v-model="modifica_contenitore">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Dettaglio Contenitore
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <!-- Bottone di salvataggio delle modifiche al contenitore -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-show="tab_contenitore != 3"
                                @click="salvaContenitore"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </template>
                        <span>Salva Contenitore</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>

                    <!-- Bottone di chiusura del dialog -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="chiudiModificaContenitore"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text style="overflow-y: auto">
                    <!-- Istruttore delle tabs -->
                    <v-tabs
                        class="mt-5"
                        v-model="tab_contenitore"
                        align-with-title
                    >
                        <v-tabs-slider color="transparent"></v-tabs-slider>
                        <v-tab
                            active-class="py-0 my-0 indigo white--text"
                            class="py-0 my-0"
                            v-for="item in contenitore_sel.id_articolo_packaging ==
                            -1
                                ? tabs_contenitore_2
                                : tabs_contenitore"
                            :key="item"
                        >
                            {{ item }}
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab_contenitore">
                        <!-- Tab dei dati generali del contenitore -->
                        <v-tab-item>
                            <v-card elevation="2" outlined class="mx-0 pa-0">
                                <v-card-text class="pb-0">
                                    <v-container fluid class="px-0">
                                        <v-row
                                            align="center"
                                            justify="center"
                                            class="px-0"
                                        >
                                            <!-- Colonna del codice packaging -->
                                            <v-col cols="2" class="py-0">
                                                <v-text-field
                                                    label="Cod. Packaging"
                                                    v-model="
                                                        contenitore_sel.cod_articolo_packaging
                                                    "
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="2" class="py-0">
                                                <v-checkbox
                                                    dense
                                                    :false-value="0"
                                                    label="Impegno Materiale"
                                                    v-model="
                                                        contenitore_sel.impegno_materiale
                                                    "
                                                    :true-value="1"
                                                >
                                                </v-checkbox>
                                            </v-col>
                                            <v-col cols="2" class="py-0">
                                                <v-text-field
                                                    label="Cod. Anagrafica"
                                                    v-model="
                                                        contenitore_sel.codice
                                                    "
                                                >
                                                </v-text-field>
                                            </v-col>

                                            <!-- Colonna della Ragione Sociale Fornitore -->
                                            <v-col cols="3" class="py-0">
                                                <v-text-field
                                                    label="Ragione Sociale Fornitore"
                                                    v-model="
                                                        contenitore_sel.ragione_sociale
                                                    "
                                                >
                                                    <template v-slot:prepend>
                                                        <v-btn
                                                            @click="
                                                                searchRagSocF
                                                            "
                                                            small
                                                        >
                                                            <v-icon
                                                                color="primary"
                                                                >mdi-magnify</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                </v-text-field>
                                            </v-col>

                                            <!-- Colonna della Ragione Sociale Cliente -->
                                            <v-col cols="3" class="py-0">
                                                <v-text-field
                                                    label="Ragione Sociale Cliente"
                                                    v-model="
                                                        contenitore_sel.ragione_sociale_c
                                                    "
                                                >
                                                    <template v-slot:prepend>
                                                        <v-btn
                                                            @click="
                                                                searchRagSocC(
                                                                    contenitore_sel.codice,
                                                                    contenitore_sel.ragione_sociale_c
                                                                )
                                                            "
                                                            small
                                                        >
                                                            <v-icon
                                                                color="primary"
                                                                >mdi-magnify</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row align="center" justify="center">
                                            <!-- Colonna dell'autocomplete del contenitore -->
                                            <v-col cols="4" class="py-0">
                                                <v-autocomplete
                                                    label="Contenitore"
                                                    :items="items_contenitori"
                                                    :item-text="
                                                        (item) =>
                                                            `${item.cod_articolo} - ${item.des_articolo}`
                                                    "
                                                    item-value="id_articolo"
                                                    v-model="
                                                        contenitore_sel.id_articolo_contenitore
                                                    "
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                            <!-- Colonna della Quantità Contenitore -->
                                            <v-col cols="2" class="py-0">
                                                <v-text-field
                                                    label="Pz. per Contenitore"
                                                    type="number"
                                                    v-model="
                                                        contenitore_sel.qta_contenitore
                                                    "
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <!-- Colonna della quantità minima -->
                                            <v-col cols="2" class="py-0">
                                                <v-text-field
                                                    label="Q.tà Min. Sped."
                                                    type="number"
                                                    v-model="
                                                        contenitore_sel.qta_minima_spedizione
                                                    "
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <!-- Colonna della quantità imballo -->
                                            <v-col cols="2" class="py-0">
                                                <v-text-field
                                                    label="N. Cont. per Imballo"
                                                    type="number"
                                                    v-model="
                                                        contenitore_sel.qta_imballo
                                                    "
                                                >
                                                </v-text-field>
                                            </v-col>

                                            <!-- Colonna dei piani per imballo -->
                                            <v-col cols="2" class="py-0">
                                                <v-text-field
                                                    label="Piani per Imballo"
                                                    type="number"
                                                    v-model="
                                                        contenitore_sel.imballo_piano
                                                    "
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <!-- Colonna della label -->
                                            <!-- <v-col cols="2" class="py-0">
                        <v-text-field
                          label="Etichetta"
                          v-model="contenitore_sel.cod_report"
                          readonly
                        >
                        </v-text-field>
                      </v-col> -->
                                            <!-- <v-col cols="1" class="py-0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              @click="clickAssociaEtichetta"
                            >
                              <v-icon color="primary"
                                >mdi-chart-box-plus-outline</v-icon
                              >
                            </v-btn>
                          </template>
                          <span>{{
                            contenitore_sel.id_label != null
                              ? "Modifica Etichetta"
                              : " Associa Etichetta"
                          }}</span>
                        </v-tooltip>
                      </v-col> -->
                                            <!-- Colonna del flag Impilabile -->
                                        </v-row>
                                        <v-row align="center" justify="start">
                                            <v-col cols="2" class="py-0">
                                                <v-text-field
                                                    label="Contenitori per piano"
                                                    type="number"
                                                    v-model="
                                                        contenitore_sel.contenitore_piano
                                                    "
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="2" class="py-0">
                                                <v-text-field
                                                    label="Peso lordo packaging (kg)"
                                                    type="number"
                                                    v-model="
                                                        contenitore_sel.peso_lordo
                                                    "
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="2" class="py-0">
                                                <v-text-field
                                                    label="Altezza pallet (cm)"
                                                    type="number"
                                                    v-model="
                                                        contenitore_sel.altezza_pallet
                                                    "
                                                >
                                                </v-text-field>
                                            </v-col>

                                            <v-col cols="2" class="py-0">
                                                <v-checkbox
                                                    class="mt-4 ml-2"
                                                    color="success"
                                                    :false-value="0"
                                                    label="Impilabile"
                                                    :true-value="1"
                                                    v-model="
                                                        contenitore_sel.impilabile
                                                    "
                                                ></v-checkbox>
                                            </v-col>
                                            <v-col cols="2" class="py-0">
                                                <v-checkbox
                                                    class="mt-4 ml-2"
                                                    color="success"
                                                    :false-value="0"
                                                    label="Predefinito"
                                                    :true-value="1"
                                                    v-model="
                                                        contenitore_sel.predefinito
                                                    "
                                                ></v-checkbox>
                                            </v-col>
                                            <v-col cols="2" class="py-0">
                                                <v-checkbox
                                                    class="mt-4 ml-2"
                                                    color="success"
                                                    :false-value="0"
                                                    label="Predefinito per Cliente"
                                                    :true-value="1"
                                                    v-model="
                                                        contenitore_sel.predefinito_per_cliente
                                                    "
                                                ></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>

                                    <v-row align="center" justify="center">
                                        <v-col cols="11" align="center">
                                            <v-divider
                                                width="100%"
                                                class="my-3"
                                            ></v-divider>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col>
                                            <v-toolbar color="indigo" dense>
                                                <v-toolbar-title
                                                    class="white--text"
                                                >
                                                    Associazioni
                                                </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-tooltip bottom>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs,
                                                        }"
                                                    >
                                                        <v-btn
                                                            :disabled="
                                                                contenitore_sel.id_articolo_packaging ==
                                                                -1
                                                            "
                                                            @click="
                                                                aggiungiAssociazione
                                                            "
                                                            small
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon
                                                                color="primary"
                                                                >mdi-plus</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span
                                                        >Agg. Associazione</span
                                                    >
                                                </v-tooltip>
                                                <v-spacer></v-spacer>
                                            </v-toolbar>
                                            <v-data-table
                                                :headers="headers_associazioni"
                                                :items="
                                                    associazioni != null
                                                        ? associazioni.filter(
                                                              (e) =>
                                                                  e.validita ==
                                                                  1
                                                          )
                                                        : []
                                                "
                                            >
                                                <!-- BOTTONE DETTAGLIO -->

                                                <template
                                                    v-slot:[`item.dettaglio`]="{
                                                        item,
                                                    }"
                                                >
                                                    <v-btn
                                                        small
                                                        @click="
                                                            goToDettaglioEichetta(
                                                                item
                                                            )
                                                        "
                                                    >
                                                        <v-icon color="primary"
                                                            >mdi-magnify</v-icon
                                                        >
                                                    </v-btn>
                                                </template>
                                                <!-- SELECT ETICHETTA -->
                                                <template
                                                    v-slot:[`item.cod_report`]="{
                                                        item,
                                                    }"
                                                >
                                                    <v-autocomplete
                                                        :items="items_labels"
                                                        item-text="cod_label"
                                                        item-value="id_label"
                                                        label="Etichetta"
                                                        :search-input="search"
                                                        v-model="item.id_label"
                                                    />
                                                </template>
                                                <template
                                                    v-slot:[`item.tipologia`]="{
                                                        item,
                                                    }"
                                                >
                                                    <v-autocomplete
                                                        :items="items_tipologia"
                                                        item-text="des"
                                                        item-value="val_int"
                                                        label="Tipologia"
                                                        v-model="item.tipologia"
                                                    />
                                                </template>
                                                <template
                                                    v-slot:[`item.applicazione`]="{
                                                        item,
                                                    }"
                                                >
                                                    <v-autocomplete
                                                        :items="
                                                            items_applicazione
                                                        "
                                                        item-text="des_applicazione"
                                                        item-value="value"
                                                        label="Applicazione"
                                                        v-model="
                                                            item.applicazione
                                                        "
                                                    />
                                                </template>
                                                <template
                                                    v-slot:[`item.numero`]="{
                                                        item,
                                                    }"
                                                >
                                                    <v-text-field
                                                        style="width: 60px"
                                                        type="number"
                                                        min="0"
                                                        v-model="item.numero"
                                                        label="Numero"
                                                    />
                                                </template>

                                                <!-- CHECKBOX -->
                                                <template
                                                    v-slot:[`item.editabile`]="{
                                                        item,
                                                    }"
                                                >
                                                    <v-checkbox
                                                        dense
                                                        v-model="item.editabile"
                                                    />
                                                </template>

                                                <template
                                                    v-slot:[`item.stampa`]="{
                                                        item,
                                                    }"
                                                >
                                                    <v-btn
                                                        :disabled="
                                                            item.id_articolo_packaging_label ==
                                                            -1
                                                        "
                                                        small
                                                        @click="
                                                            GetEtichettaPDF(
                                                                item
                                                            )
                                                        "
                                                    >
                                                        <v-icon color="primary"
                                                            >mdi-printer</v-icon
                                                        >
                                                    </v-btn>
                                                </template>

                                                <!-- BOTTONE ELIMINA -->
                                                <template
                                                    v-slot:[`item.elimina`]="{
                                                        item,
                                                    }"
                                                >
                                                    <v-btn
                                                        small
                                                        @click="
                                                            eliminaAssociazione(
                                                                item
                                                            )
                                                        "
                                                    >
                                                        <v-icon color="error"
                                                            >mdi-close</v-icon
                                                        >
                                                    </v-btn>
                                                </template>
                                            </v-data-table>
                                        </v-col>
                                    </v-row>

                                    <v-container>
                                        <v-row>
                                            <v-col cols="4">
                                                <v-row>
                                                    <v-col align="left">
                                                        <span
                                                            style="
                                                                color: black;
                                                                font-size: 18px;
                                                            "
                                                        >
                                                            <b>BOM Imballo:</b>
                                                            <div
                                                                style="
                                                                    display: inline-block;
                                                                "
                                                            >
                                                                <v-tooltip
                                                                    bottom
                                                                >
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs,
                                                                        }"
                                                                    >
                                                                        <v-btn
                                                                            class="ml-5"
                                                                            @click="
                                                                                aggiungiImballo
                                                                            "
                                                                            small
                                                                            v-bind="
                                                                                attrs
                                                                            "
                                                                            v-on="
                                                                                on
                                                                            "
                                                                        >
                                                                            <v-icon
                                                                                color="primary"
                                                                            >
                                                                                mdi-package-variant
                                                                            </v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span
                                                                        >Aggiungi
                                                                        BOM
                                                                        Imballo</span
                                                                    >
                                                                </v-tooltip>
                                                            </div>
                                                        </span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-row>
                                                        <v-col
                                                            class="mb-5"
                                                            cols="12"
                                                            align="left"
                                                        >
                                                            <v-treeview
                                                                :items="
                                                                    items_bom_imballo
                                                                "
                                                                item-key="id"
                                                                open-on-click
                                                            ></v-treeview>
                                                        </v-col>
                                                    </v-row>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <!-- Tab delle istruzioni imballo -->
                            <v-card elevation="2" class="mx-0 pa-0">
                                <v-card-text class="ma-0 pa-0">
                                    <v-data-table
                                        :headers="headers_istruzioni"
                                        :items="
                                            items_istruzioni != null
                                                ? items_istruzioni.filter(
                                                      (e) => e.validita === 1
                                                  )
                                                : []
                                        "
                                        height="50vh"
                                        fixed-header
                                    >
                                        <template v-slot:top>
                                            <v-toolbar color="indigo" dense>
                                                <v-toolbar-title
                                                    class="white--text"
                                                >
                                                    Istruzioni d'Imballaggio
                                                </v-toolbar-title>

                                                <v-spacer></v-spacer>

                                                <!-- Pulsante di aggiunta istruzione -->
                                                <v-tooltip bottom>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs,
                                                        }"
                                                    >
                                                        <v-btn
                                                            @click="
                                                                aggiungiIstruzione
                                                            "
                                                            small
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon
                                                                color="primary"
                                                            >
                                                                mdi-plus
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span
                                                        >Aggiungi
                                                        Istruzione</span
                                                    >
                                                </v-tooltip>
                                                <v-spacer></v-spacer>
                                            </v-toolbar>
                                        </template>

                                        <!-- Colonna dell'indice -->
                                        <template
                                            v-slot:[`item.indice`]="{ item }"
                                        >
                                            <b>{{ item.indice }}</b>
                                        </template>

                                        <!-- Bottone di modifica delle istruzioni -->
                                        <template
                                            v-slot:[`item.modifica`]="{ item }"
                                        >
                                            <v-tooltip bottom>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-btn
                                                        class="mr-5"
                                                        @click="
                                                            modificaIstruzione(
                                                                item
                                                            )
                                                        "
                                                        small
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon color="primary">
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Modifica Istruzione</span>
                                            </v-tooltip>
                                        </template>

                                        <!-- Bottone di eliminazione delle istruzioni -->
                                        <template
                                            v-slot:[`item.elimina`]="{ item }"
                                        >
                                            <v-tooltip bottom>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-btn
                                                        class="mr-5"
                                                        @click="
                                                            clickEliminaIstruzione(
                                                                item
                                                            )
                                                        "
                                                        small
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon color="error">
                                                            mdi-close
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Elimina Istruzione</span>
                                            </v-tooltip>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <!-- Card degli allegati -->
                            <v-card style="height: 75vh">
                                <v-card v-if="input_args.id_riferimento == -1">
                                    <v-card-text>
                                        <span style="font-size: 18px">
                                            Salvare il packaging prima di
                                            aggiungere gli allegati relativi.
                                        </span>
                                    </v-card-text>
                                </v-card>
                                <div
                                    style="position: relative; height: 100%"
                                    v-else
                                >
                                    <WindowFrame
                                        class="ma-0 pa-0"
                                        referrerpolicy="origin"
                                        :component="'allegati'"
                                        ref="windowframe_allegati"
                                        :input_args="input_args"
                                        :key="key_allegati"
                                    />
                                </div>
                                <!--<GestioneAllegato
                  controller_allegati="Global"
                  controller_caratteristiche_tabella="Magazzino"
                  :headers_allegati_scelti="headers_allegati_scelti"
                  :id_riferimento="contenitore_sel.id_articolo_packaging"
                  :key="key_allegati"
                  ref="componenteAllegati"
                  :show_close="false"
                  @snackbarOpen="snackbarOpen"
                  tipo_allegato="PACKAGING"
                  :toolbar_title="'Documenti Associati'"
                />-->
                            </v-card>
                        </v-tab-item>
                        <!-- TAB NEW Packaging -->
                        <v-tab-item>
                            <v-card>
                                <GestionePackaging
                                    :key="key_gestione_pack"
                                    :quicklabel_allowed="quicklabel_allowed"
                                    :packaging="contenitore_sel"
                                    :data="data"
                                    @getarticolipackaging="
                                        emitGetArticoliPackaging
                                    "
                                />
                            </v-card>
                        </v-tab-item>
                        <!-- <v-tab-item>
              <v-card elevation="2">
                <v-card-text class="mx-0 pa-0">
                  <v-data-table
                    :headers="headers_partner"
                    height="40vh"
                    :items="items_partner"
                  >
                    <template v-slot:top>
                      <v-toolbar color="indigo" dense>
                        <v-row align="center" justify="center">
                          <v-col align="left" cols="4" justify="center">
                            <v-toolbar-title class="white--text">
                              Lista Partner
                            </v-toolbar-title>
                          </v-col>
                          <v-col align="center" cols="4" justify="center">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="searchRagSocC('*', '')"
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon color="primary"> mdi-plus </v-icon>
                                </v-btn>
                              </template>
                              <span>Aggiungi Partner</span>
                            </v-tooltip>
                          </v-col>
                          <v-col
                            align="right"
                            cols="4"
                            justify="center"
                          ></v-col>
                        </v-row>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.elimina`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="clickEliminaPartner(item)"
                            small
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="error"> mdi-delete </v-icon>
                          </v-btn>
                        </template>
                        <span>Elimina</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item> -->
                    </v-tabs-items>
                </v-card-text>
            </v-card>
            <!-- Overlay -->
            <v-overlay :value="caricamento_dati">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </v-dialog>

        <v-dialog v-model="pdfdialog" width="800">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text">
                        Stampa Etichetta</v-toolbar-title
                    >

                    <v-spacer></v-spacer>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="pdfdialog = false" small>
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-progress-linear
                    indeterminate
                    color="cyan"
                    v-if="loading"
                    id="progress"
                >
                </v-progress-linear>

                <v-col cols="12">
                    <iframe
                        :src="selected_pdf"
                        frameborder="0"
                        style="height: 70vh !important; width: 750px !important"
                    >
                    </iframe>
                </v-col>
            </v-card>
        </v-dialog>

        <!-- Dialog di ricerca delle anagrafiche -->
        <v-dialog v-model="dialog_ricerca_anagrafiche">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text mr-5">
                        Ricerca Anagrafica
                    </v-toolbar-title>
                    <v-text-field
                        class="mr-5"
                        dense
                        hide-details
                        label="Cod. Anagrafica"
                        outlined
                        style="
                            background-color: white;
                            border-radius: 0px;
                            max-width: 250px;
                        "
                        v-model="cod_anagrafica_search"
                    >
                        <template v-slot:append>
                            <v-btn
                                @click="cod_anagrafica_search = ''"
                                icon
                                small
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                    <v-text-field
                        dense
                        hide-details
                        label="Ragione Sociale"
                        outlined
                        style="
                            background-color: white;
                            border-radius: 0px;
                            max-width: 250px;
                        "
                        v-model="ragione_sociale_search"
                    >
                        <template v-slot:append>
                            <v-btn
                                @click="ragione_sociale_search = ''"
                                icon
                                small
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="chiudiScegliAnagrafica"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text style="overflow-y: auto">
                    <v-data-table
                        :headers="headers_ricerca_anagrafica"
                        height="60vh"
                        :items="items_anagrafiche_visualizzate"
                    >
                        <!-- Bottone di selezione dell'anagrafica -->
                        <template v-slot:[`item.seleziona`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        class="mr-5"
                                        @click="selezionaAnagrafica(item)"
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon color="success">
                                            mdi-check
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Seleziona Anagrafica</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog di ricerca degli imballi -->
        <v-dialog v-model="dialog_ricerca_imballi">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text"
                        >Ricerca Imballo</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="chiudiScegliImballo"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text style="overflow-y: auto">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <div>
                                    <div style="display: inline-block">
                                        <v-text-field
                                            v-on:keydown.enter.prevent="
                                                searchImballo
                                            "
                                            v-model="cod_imballo"
                                            label="Cod. Imballo"
                                            required
                                            style="max-width: 200px"
                                        >
                                        </v-text-field>
                                    </div>
                                    <div style="display: inline-block">
                                        <v-btn
                                            class="mx-5"
                                            @click="searchImballo"
                                            small
                                        >
                                            <v-icon color="primary">
                                                mdi-magnify
                                            </v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-data-table
                        :headers="headers_ricerca_imballo"
                        height="50vh"
                        :items="items_scelta_imballo"
                    >
                        <!-- Titolo della tabella degli imballi disponibili -->
                        <template v-slot:top>
                            <v-toolbar color="indigo" dense>
                                <v-toolbar-title class="white--text">
                                    Imballi Disponibili
                                </v-toolbar-title>
                            </v-toolbar>
                        </template>

                        <!-- Bottone di selezione dell'imballo -->
                        <template v-slot:[`item.seleziona`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        class="mr-5"
                                        @click="selezionaImballo(item)"
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon color="success">
                                            mdi-check
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Seleziona Imballo</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog di modifica dell'istruzione -->
        <v-dialog v-model="modifica_istruzione_dialog" width="500px">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Modifica Istruzione
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="salvaIstruzione"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva Istruzione</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="chiudiModificaIstruzione"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row align="center" justify="center">
                            <v-col cols="12" align="center">
                                <v-text-field
                                    v-model="istruzione_sel.des_istruzione"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog di conferma eliminazione contenitore -->
        <v-dialog v-model="conf_del_cont_dialog" width="500px">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Conferma Eliminazione
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="mt-3 mb-0 pb-0" style="overflow-y: auto">
                    <span style="color: black; font-size: 18px">
                        Confermi di voler eliminare il contenitore alternativo
                        selezionato?</span
                    >

                    <v-divider class="my-3"></v-divider>

                    <v-container>
                        <v-row
                            align="center"
                            justify="center"
                            class="py-0 my-0"
                        >
                            <v-col cols="12" align="center" class="py-0 my-0">
                                <v-btn
                                    class="mr-5"
                                    @click="conf_del_cont_dialog = false"
                                    small
                                >
                                    <v-icon color="error">mdi-close</v-icon>
                                </v-btn>
                                <v-btn @click="eliminaContenitore" small>
                                    <v-icon color="success">mdi-check</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog di conferma eliminazione istruzione -->
        <v-dialog v-model="conf_del_ins_dialog" width="500px">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Conferma Eliminazione
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="mt-3 mb-0 pb-0" style="overflow-y: auto">
                    <span style="color: black; font-size: 18px"
                        >Confermi di voler eliminare l'istruzione d'imballo
                        selezionata?
                    </span>

                    <v-divider class="my-3"></v-divider>

                    <v-container>
                        <v-row
                            align="center"
                            justify="center"
                            class="py-0 my-0"
                        >
                            <v-col cols="12" align="center" class="py-0 my-0">
                                <v-btn
                                    class="mr-5"
                                    @click="conf_del_ins_dialog = false"
                                    small
                                >
                                    <v-icon color="error">mdi-close</v-icon>
                                </v-btn>
                                <v-btn @click="eliminaIstruzione" small>
                                    <v-icon color="success">mdi-check</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog Associa Etichetta -->
        <!-- <v-dialog v-model="show_associa_etichetta" width="400">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Associa Etichetta
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="setAssociazione" small v-bind="attrs" v-on="on">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva Associazione</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickChiuduAssociaEtichetta"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-row align="center" justify="center" class="mt-2">
            <v-col>
              <v-autocomplete
                :items="items_labels"
                item-text="cod_report"
                item-value="id_report"
                label="Etichetta"
                v-model="contenitore_sel.id_label"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="3" v-if="report_sel != null">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="goToDettaglioEichetta"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Dettaglio Etichetta</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog> -->

        <!-- Dialog di conferma eliminazione dei partner -->
        <v-dialog v-model="conferma_elimina_partner" width="unset">
            <v-card style="max-width: 500px">
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Eliminazione
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="mt-5" style="overflow-y: auto">
                    <span style="color: rgb(0, 0, 0); font-size: 18px">
                        Confermi di voler eliminare l'associazione al partner
                        selezionato?
                    </span>
                    <v-divider class="my-5"></v-divider>
                    <v-container>
                        <v-row align="center" justify="center">
                            <v-col class="my-0 py-0" justify="center" cols="12">
                                <v-btn
                                    class="mr-5"
                                    @click="conferma_elimina_partner = false"
                                    small
                                >
                                    <v-icon color="error"> mdi-close </v-icon>
                                </v-btn>

                                <v-btn small>
                                    <v-icon color="success"> mdi-check </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog Dettaglio Etichetta -->
        <v-dialog v-model="show_dettaglio_etichetta">
            <div style="overflow: hidden">
                <QuickLabelDetail
                    :key="key"
                    :etichetta="label.modello"
                    :etichetta_base64="label.base64"
                    @goToLista="chiudiDialogDettaglio"
                    :show_off="true"
                    :show_tab_off="true"
                />
            </div>
        </v-dialog>

        <!-- Dialog Stampa Etichetta -->
        <v-dialog v-model="dialog_print" width="unset">
            <v-card style="max-width: 500px">
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Stampa Etichetta
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="goToPrinter()"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Stampa</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="closePrintDialog"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text class="mt-5" style="overflow-y: auto">
                    <v-row justify="center" align="center">
                        <v-col cols="8">
                            <span style="font-size: 18px">
                                Quante etichette vuoi stampare?
                            </span>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="qta_stampa"
                                label="Quantità"
                                required
                                type="number"
                            />
                        </v-col>
                    </v-row>

                    <!-- <v-divider class="my-5"></v-divider> -->
                    <!-- <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="dialog_print = false" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container> -->
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Overlay -->
        <v-overlay :value="caricamento_dati">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />
    </v-card>
</template>
<script>
import _ from "lodash";
//import GestioneAllegato from "@/components/TOOLS/GestioneAllegato.vue";
import GestionePackaging from "@/components/TOOLS/GestionePackaging.vue";
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import QuickLabelDetail from "@/views/LABEL/QuickLabelDetail";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import { FrxToJson } from "@/views/LABEL/FrxJsonConverter";

class Associazione {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }

    // Metodo per resettare tutte le campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "applicazione", default_val: 0 },
            { nome: "editabile", default_val: 0 },
            { nome: "id_articolo_packaging", default_val: null },
            { nome: "id_articolo_packaging_label", default_val: -1 },
            { nome: "id_label", default_val: null },
            { nome: "numero", default_val: 0 },
            { nome: "predefinito", default_val: 0 },
            { nome: "predefinito_per_cliente", default_val: 0 },
            { nome: "tipologia", default_val: 0 },
            { nome: "validita", default_val: 1 },
        ];

        return campi;
    }
}
class Contenitore {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }

    // Metodo per resettare tutte le campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "altezza_pallet", default_val: 0 },
            { nome: "codice", default_val: "" },
            { nome: "cod_confezione", default_val: "" },
            { nome: "cod_contenitore", default_val: "" },
            { nome: "cod_imballo", default_val: "" },
            { nome: "cod_articolo_packaging", default_val: "" },
            { nome: "contenitore_piano", default_val: 0 },
            { nome: "des_contenitore", default_val: "" },
            { nome: "des_imballo", default_val: "" },
            { nome: "id_anagrafica", default_val: null },
            { nome: "id_articolo", default_val: null },
            { nome: "id_articolo_contenitore", default_val: null },
            { nome: "id_articolo_imballo", default_val: null },
            { nome: "id_articolo_packaging", default_val: -1 },
            { nome: "id_label", default_val: null },
            { nome: "imballo_piano", default_val: 0 },
            { nome: "impegno_materiale", default_val: 0 },
            { nome: "impilabile", default_val: 0 },
            { nome: "qta_confezione", default_val: 0 },
            { nome: "qta_contenitore", default_val: 0 },
            { nome: "qta_imballo", default_val: 0 },
            { nome: "qta_minima_spedizione", default_val: 0 },
            { nome: "nr_immagini", default_val: 0 },
            { nome: "nr_istruzioni", default_val: 0 },
            { nome: "peso_lordo", default_val: 0 },
            { nome: "predefinito", default_val: 0 },
            { nome: "predefinito_per_cliente", default_val: 0 },
            { nome: "ragione_sociale", default_val: "" },
            { nome: "ragione_sociale_c", default_val: "" },
            { nome: "validita", default_val: 1 },
        ];

        return campi;
    }
}

class Istruzione {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }

    // Metodo per resettare tutte le campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "des_istruzione", default_val: "" },
            { nome: "id_pack_istruzioni", default_val: -1 },
            { nome: "indice", default_val: null },
            { nome: "validita", default_val: 1 },
        ];

        return campi;
    }
}

export default {
    name: "",
    components: {
        //GestioneAllegato,
        GestionePackaging,
        SnackbarQV,
        QuickLabelDetail /*ReportPage*/,
        WindowFrame,
    },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
        componente_esterno: {
            type: Boolean,
            default: false,
        },
        custom_headers: {
            type: Array,
            default: () => [],
        },
        pack_id_commessa_sel: {
            type: Number,
            default: null,
        },
        quicklabel_allowed: {
            type: Number,
            default: 0,
        },
        show_exit_button: {
            type: Boolean,
            default: false,
        },
        show_save_button: {
            type: Boolean,
            default: false,
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // Variabili d'appoggio
            pdfdialog: false,
            selected_pdf: "",
            search: "",
            cod_imballo: "",
            cod_anagrafica_search: "",
            contenitore_sel: new Contenitore(),
            istruzione_sel: new Istruzione(),
            partner_sel: null,
            etichetta: null,
            etichetta_print: null,
            input_args: {
                cod_riferimento: "articolo_packaging",
                id_riferimento: -1,
                id_utente: localStorage.id,
                pk_riferimento: "id_articolo_packaging",
                show_close: false,
            },
            key: 0,
            key_allegati: 0,
            key_gestione_pack: false,
            label: {
                modello: null,
                base64: "",
            },
            modello_originale: null,
            id_articolo_packaging_label: null,
            key_tabella: 0,
            ragione_sociale_search: "",

            // Modal
            caricamento_dati: false,
            conf_del_cont_dialog: false,
            conf_del_ins_dialog: false,
            conferma_elimina_partner: false,
            dialog_print: false,
            dialog_ricerca_anagrafiche: false,
            dialog_ricerca_imballi: false,
            etichetta_sel: null,
            is_anagrafica_fornitore: false,
            loading: false,
            modifica_contenitore: false,
            modifica_istruzione_dialog: false,
            qta_stampa: null,
            report_sel: null,
            show_associa_etichetta: false,
            show_dettaglio_etichetta: false,

            // Array
            associazioni: [],
            etichette_contenitori: new Array(),
            items_stato: [
                { des_stato: "Approvato", value: 0 },
                { des_stato: "Non approvato", value: 1 },
                { des_stato: "In approvazione", value: 2 },
            ],
            items_applicazione: [
                { des_applicazione: "Imballo", value: 0 },
                { des_applicazione: "Contenitore", value: 1 },
            ],
            items_tipologia: [
                { des_tipologia: "Standard", value: 0 },
                { des_tipologia: "Controetichetta", value: 1 },
            ],
            headers_allegati_scelti: [
                {
                    text: "Scarica",
                    value: "scarica",
                    sortable: false,
                },
                {
                    text: "Descrizione",
                    value: "des_allegato",
                    sortable: false,
                },
                {
                    text: "Data Validità",
                    value: "data_validita",
                    sortable: false,
                },
                {
                    text: "Caricato da",
                    value: "nominativo",
                    sortable: false,
                },
                {
                    text: "Preview",
                    value: "preview",
                    sortable: false,
                },
                {
                    text: "Elimina",
                    value: "elimina",
                    sortable: false,
                },
            ],
            headers_contenitori_alternativi: [
                {
                    text: "Modifica",
                    value: "modifica",
                    sortable: false,
                },
                {
                    text: "Predefinito",
                    value: "predefinito",
                    sortable: false,
                },
                {
                    text: "Pred. Cli.",
                    value: "predefinito_per_cliente",
                    sortable: false,
                },
                {
                    text: "Cod. Packaging",
                    value: "cod_articolo_packaging",
                    sortable: false,
                },
                {
                    text: "Ragione Sociale",
                    value: "ragione_sociale",
                    sortable: false,
                },
                {
                    text: "Tipo Contenitore",
                    value: "des_contenitore",
                    sortable: false,
                },
                {
                    text: "Q.tà Contenitore",
                    value: "qta_contenitore",
                    sortable: false,
                },
                {
                    text: "Tipo Imballo",
                    value: "des_imballo",
                    sortable: false,
                },
                {
                    text: "Q.tà Imballo",
                    value: "qta_imballo",
                    sortable: false,
                },
                {
                    text: "Q.tà Minima Spedizione",
                    value: "qta_minima_spedizione",
                    sortable: false,
                },
                {
                    text: "Elimina",
                    value: "elimina",
                    sortable: false,
                },
            ],

            headers_ricerca_anagrafica: [
                {
                    text: "Seleziona",
                    value: "seleziona",
                    sortable: false,
                },
                {
                    text: "Tipo",
                    value: "_tipo",
                    sortable: false,
                },
                {
                    text: "Codice",
                    value: "codice",
                    sortable: false,
                },
                {
                    text: "Ragione Sociale",
                    value: "ragione_sociale",
                    sortable: false,
                },
                {
                    text: "Indrizzo",
                    value: "indirizzo",
                    sortable: false,
                },
            ],
            headers_ricerca_imballo: [
                {
                    text: "Seleziona",
                    value: "seleziona",
                    sortable: false,
                },
                {
                    text: "Codice Articolo",
                    value: "cod_articolo",
                    sortable: false,
                },
                {
                    text: "Des. Ariticolo",
                    value: "des_articolo",
                    sortable: false,
                },
                {
                    text: "Fam. Articolo",
                    value: "fam_articolo",
                    sortable: false,
                },
            ],
            headers_istruzioni: [
                {
                    text: "Indice",
                    value: "indice",
                    width: "150px",
                    sortable: false,
                },
                {
                    text: "Modifica",
                    value: "modifica",
                    width: "150px",
                    sortable: false,
                },
                {
                    text: "Des. Istruzione",
                    value: "des_istruzione",
                    sortable: false,
                },
                {
                    text: "Elimina",
                    value: "elimina",
                    width: "150px",
                    sortable: false,
                },
            ],
            headers_associazioni: [
                {
                    text: "Stampa",
                    value: "stampa",
                    sortable: false,
                },
                {
                    text: "Dettaglio",
                    value: "dettaglio",
                    sortable: false,
                },
                {
                    text: "Cod. Etichetta",
                    value: "cod_report",
                    sortable: false,
                },
                {
                    text: "Tipologia",
                    value: "tipologia",
                    sortable: false,
                },
                {
                    text: "Applicazione",
                    value: "applicazione",
                    sortable: false,
                },
                {
                    text: "Numero",
                    value: "numero",
                    sortable: false,
                },
                {
                    text: "Editabile",
                    value: "editabile",
                    sortable: false,
                },

                {
                    text: "Elimina",
                    value: "elimina",
                    sortable: false,
                },
            ],
            headers_partner: [
                {
                    text: "Codice",
                    value: "codice",
                    sortable: false,
                },
                {
                    text: "Ragione Sociale",
                    value: "ragione_sociale",
                    sortable: false,
                },
                {
                    text: "Localita",
                    value: "localita",
                    sortable: false,
                },
                {
                    text: "Indirizzo",
                    value: "indirizzo",
                    sortable: false,
                },
                {
                    text: "Elimina",
                    value: "elimina",
                    sortable: false,
                },
            ],
            items_anagrafiche: new Array(),
            items_anagrafiche_visualizzate: new Array(),
            items_bom_imballo: new Array(),
            items_contenitori: new Array(),
            items_contenitori_alternativi: new Array(),
            items_imballi: new Array(),
            items_istruzioni: new Array(),
            items_labels: new Array(),
            items_partner: new Array(),
            items_scelta_imballo: new Array(),
            tab_contenitore: [],
            tabs_contenitore: [
                "Generale",
                "Istruzioni",
                "Allegati",
                "Gestione Packaging",
            ],
            tabs_contenitore_2: [
                "Generale",
                "Istruzioni",
                "Allegati",
                "Gestione Packaging",
            ],
        };
    },
    computed: {},
    watch: {
        cod_anagrafica_search: {
            immediate: true,
            handler() {
                this.filtra();
            },
        },
        quicklabel_allowed: {
            immediate: true,
            handler() {
                this.getReports();
            },
        },
        ragione_sociale_search: {
            immediate: true,
            handler() {
                this.filtra();
            },
        },
        tab_contenitore: {
            immediate: true,
            handler() {
                if (this.tab_contenitore == 2) {
                    this.key_allegati = this.key_allegati == 0 ? 1 : 0;
                } else if (this.tab_contenitore == 3) {
                    this.key_gestione_pack =
                        this.key_gestione_pack == 0 ? 1 : 0;
                }
            },
        },
        visible: {
            immediate: true,
            handler() {
                if (this.visible === true) {
                    if (this.custom_headers.length > 0) {
                        this.headers_contenitori_alternativi = new Array();
                        this.custom_headers.forEach((e) => {
                            this.headers_contenitori_alternativi.push(
                                Object.assign({}, e)
                            );
                        });
                    }
                }
                if (this.pack_id_commessa_sel != null) {
                    this.items_contenitori_alternativi.forEach((c) => {
                        if (
                            c.id_articolo_packaging == this.pack_id_commessa_sel
                        ) {
                            this.$set(c, "selected_for_commessa", 1);
                        } else {
                            this.$set(c, "selected_for_commessa", 0);
                        }
                    });
                }
            },
        },
    },
    methods: {
        aggiungiAssociazione() {
            let associazione_tmp = new Associazione();
            associazione_tmp.id_articolo_packaging =
                this.contenitore_sel.id_articolo_packaging;
            this.associazioni.push(associazione_tmp);
        },
        aggiungiContenitore() {
            this.key_gestione_pack = !this.key_gestione_pack;
            this.contenitore_sel = new Contenitore();
            /* Aggiusto gli input_args perché abbiano un valore coerente. */
            this.input_args.id_riferimento = -1;

            /* Forzo il refresh del componente degli allegati,
             * altrimenti potrei ancora vedere quelli dell'ultimo
             * articolo che ho modificato. (controllo in teoria
             * non più necessario perché sostituito più efficacemente
             * dal watch su tab_contenitore). */
            //this.key_allegati = this.key_allegati === 0 ? 1 : 0;
            this.modifica_contenitore = true;
        },
        aggiungiImballo() {
            this.dialog_ricerca_imballi = true;
        },
        aggiungiIstruzione() {
            this.istruzione_sel = new Istruzione();
            this.modifica_istruzione_dialog = true;
        },
        chiudiDialogDettaglio() {
            this.label.modello = null;
            this.label.base64 = "";
            this.show_dettaglio_etichetta = false;
        },
        chiudiModificaContenitore() {
            // Chiudo il dialog e resetto il contenitore.
            this.modifica_contenitore = false;
            this.associazioni = new Array();
            this.tab_contenitore = new Array();
            this.contenitore_sel = new Contenitore();

            /* Resetto le istruzioni e la distinta base della BOM
             * imballo che non sono contenute nell'oggetto Contenitore. */
            this.items_bom_imballo = new Array();
            this.items_istruzioni = new Array();

            /* Emetto un evento per segnalare che la finestra di dialogo è stata chiusa.
             * Questa informazione è utile per quei componenti che montano questo
             * file come componente figlio, perché ad esempio nell'Avanzamento Produzione
             * significa che la procedura di SPACK è stata completata e bisogna eseguire
             * una postquery. */
            this.$emit("chiuso_dettaglio_dialog");
        },
        chiudiModificaIstruzione() {
            this.istruzione_sel = new Istruzione();
            this.modifica_istruzione_dialog = false;
        },
        chiudiScegliAnagrafica() {
            this.dialog_ricerca_anagrafiche = false;
        },
        chiudiScegliImballo() {
            this.dialog_ricerca_imballi = false;
        },
        clickAssociaEtichetta() {
            this.show_associa_etichetta = true;
        },
        clickChiuduAssociaEtichetta() {
            this.show_associa_etichetta = false;
        },
        clickEliminaContenitore(arg) {
            this.contenitore_sel = new Contenitore(arg);
            this.conf_del_cont_dialog = true;
        },
        clickEliminaIstruzione(arg) {
            this.istruzione_sel = new Istruzione(arg);
            this.conf_del_ins_dialog = true;
        },
        clickReportConfezione(item) {
            console.log(item);
        },
        closePrintDialog() {
            this.qta_stampa = null;
            this.etichetta_print = null;
            this.dialog_print = false;
        },
        eliminaAssociazione(item) {
            item.validita = 0;
            if (item.id_articolo_packaging_label != -1) {
                this.setAssociazione(1);
            } else {
                this.associazioni = this.associazioni.filter(
                    (e) => e.validita != 0
                );
            }
        },
        eliminaContenitore() {
            // Mi faccio un oggetto temporaneo con i dati del contenitore da salvare
            const contenitore_tmp = new Contenitore(this.contenitore_sel);
            contenitore_tmp.validita = 0;

            const setPackaging = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setarticolopackaging",
                    token: localStorage.getItem("user_token"),
                    id_articolo: this.data.id_articolo,
                    articolo_packaging: [contenitore_tmp],
                    /* Il campo per le immagini era della vecchia gestione,
                     * ora sarà sempre vuoto perché usiamo gli allegati. */
                    articolo_packaging_immagini: [],
                    articolo_packaging_istruzioni: [],
                },
            };

            // Attivo l'overlay dicaricamento mentre aspetto la response.
            this.caricamento_dati = true;

            this.$store
                .dispatch("api", setPackaging)
                .then((res) => {
                    // Se la risposta arriva, disattivo l'overlay di caricamento
                    this.caricamento_dati = false;

                    if (res.status === 200) {
                        var request = {
                            controller: "Label",
                            method: "PUT",
                            richiesta: {
                                action: "eliminapackaginglabel",
                                token: localStorage.getItem("user_token"),
                                id_articolo_packaging:
                                    contenitore_tmp.id_articolo_packaging,
                            },
                        };

                        this.$store
                            .dispatch("api", request)
                            .then((res) => {
                                if (res.status === 200) {
                                    this.show_associa_etichetta = false;
                                }
                            })
                            .catch(() => {
                                this.caricamento_dati = false;
                                this.$refs.SnackbarQV.print(
                                    "error",
                                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                );
                            });

                        // Ricarico i dati aggiornati e stampo una snackbar di conferma.
                        this.conf_del_cont_dialog = false;
                        this.contenitore_sel = new Contenitore();
                        this.fetchPackaging();
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Contenitore Alternativo eliminato con successo.",
                            5000
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, impossibile procedere all'eliminazione."
                        );
                    }
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, impossibile procedere all'eliminazione."
                    );
                });
        },
        eliminaIstruzione() {
            for (let i = 0; i < this.items_istruzioni.length; i++) {
                if (
                    this.items_istruzioni[i].id_pack_istruzioni ===
                    this.istruzione_sel.id_pack_istruzioni
                ) {
                    this.items_istruzioni[i].validita = 0;
                }
            }

            this.conf_del_ins_dialog = false;
            this.istruzione_sel = new Istruzione();
            this.setIndiceRicorsivo(this.items_istruzioni);
        },
        // clickEliminaPartner(arg) {
        //   this.partner_sel = {
        //     id_articolo_packaging_partner: arg.id_articolo_packaging_partner,
        //     validita: 0,
        //   };

        //   this.conferma_elimina_partner = true;
        // },
        // eliminaPartner() {
        //   const request = {
        //     controller: "Magazzino",
        //     method: "PUT",
        //     richiesta: {
        //       action: "setpackagingpartner",
        //       token: localStorage.user_token,
        //       partner: [this.partner_sel],
        //     },
        //   };

        //   this.$store
        //     .dispatch("api", request)
        //     .then((res) => {
        //       if (res.status === 200) {
        //         this.conferma_elimina_partner = false;
        //         this.getPackagingPartner();
        //       } else {
        //         this.$refs.SnackbarQV.print(
        //           "orange",
        //           "Errore di comunicazione col server, non è stato possibile caricare i dati."
        //         );
        //       }
        //     })
        //     .catch((e) => {
        //       this.$refs.SnackbarQV.print(
        //         "error",
        //         "Errore di comunicazione col server, non è stato possibile caricare i dati."
        //       );
        //       console.error(e);
        //     });
        // },
        emitGetArticoliPackaging() {
            // Resetto la tab selezionata.
            this.tab_contenitore = 0;

            /* Emetto un evento per segnalare che la finestra di dialogo è stata chiusa.
             * Questa informazione è utile per quei componenti che montano questo
             * file come componente figlio, perché ad esempio nell'Avanzamento Produzione
             * significa che la procedura di SPACK è stata completata e bisogna eseguire
             * una postquery. */
            this.$emit("chiuso_dettaglio_dialog");
            this.modifica_contenitore = false;
            this.fetchPackaging();
        },
        fetchPackaging() {
            this.caricamento_dati = true;

            let getPackaging = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticolipackaging",
                    token: localStorage.getItem("user_token"),
                    id_articolo: this.data.id_articolo,
                },
            };
            return this.$store
                .dispatch("api", getPackaging)
                .then((res) => {
                    // Se la risposta arriva fermo l'overlay di caricamento
                    this.caricamento_dati = false;
                    this.associazioni = [];
                    if (res.status === 200) {
                        // Se la risposta è ok, registro i dati che mi sono arrivati
                        this.items_contenitori_alternativi = Array.from(
                            res.data
                        );
                        if (this.pack_id_commessa_sel == null) {
                            this.items_contenitori_alternativi.forEach((e) => {
                                if (e.predefinito == 1) {
                                    e.selected_for_commessa = 1;
                                }
                            });
                        } else {
                            this.items_contenitori_alternativi.forEach((e) => {
                                if (
                                    e.id_articolo_packaging ==
                                    this.pack_id_commessa_sel
                                ) {
                                    e.selected_for_commessa = 1;
                                } else {
                                    e.selected_for_commessa = 0;
                                }
                            });
                        }
                        return true;
                    } else {
                        // Se ci sono stati problemi stampo un avviso
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                        return false;
                    }
                })
                .catch(() => {
                    // Se c'è stato un errore fermo l'overlay di caricamento e stampo un avviso
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                    return false;
                });
        },
        filtra() {
            let items_anagrafiche_tmp = [];
            this.items_anagrafiche.forEach((elem) => {
                items_anagrafiche_tmp.push(elem);
            });
            // Filtro il cod anagrafica.
            if (
                this.cod_anagrafica_search != "" &&
                this.cod_anagrafica_search != null
            ) {
                let res = [];
                items_anagrafiche_tmp.forEach((elem) => {
                    if (
                        elem.codice &&
                        elem.codice
                            .toUpperCase()
                            .includes(this.cod_anagrafica_search.toUpperCase())
                    ) {
                        res.push(elem);
                    }
                });
                items_anagrafiche_tmp = res;
            }

            // Filtro la ragione sociale.
            if (
                this.ragione_sociale_search != "" &&
                this.ragione_sociale_search != null
            ) {
                let res = [];
                items_anagrafiche_tmp.forEach((elem) => {
                    if (
                        elem.ragione_sociale &&
                        elem.ragione_sociale
                            .toUpperCase()
                            .includes(this.ragione_sociale_search.toUpperCase())
                    ) {
                        res.push(elem);
                    }
                });
                items_anagrafiche_tmp = res;
            }

            this.items_anagrafiche_visualizzate = [];
            this.items_anagrafiche_visualizzate = items_anagrafiche_tmp;
        },
        // getAnagrafica() {
        //   this.caricamento_dati = true;

        //   const getAnagrafica = {
        //     controller: "Magazzino",
        //     method: "POST",
        //     richiesta: {
        //       action: "getanagrafica",
        //       tipo: "F",
        //       token: localStorage.getItem("user_token"),
        //     },
        //   };

        //   this.$store
        //     .dispatch("api", getAnagrafica)
        //     .then((res) => {
        //       // Se la risposta arriva fermo l'overlay di caricamento
        //       this.caricamento_dati = false;
        //       if (res.status === 200) {
        //         // Se la risposta è ok, registro i dati che mi sono arrivati
        //         this.items_anagrafiche = Array.from(res.data);
        //       } else {
        //         // Se ci sono stati problemi stampo un avviso
        //         this.$refs.SnackbarQV.print(
        //           "orange",
        //           "Errore di comunicazione col server, non è stato possibile caricare i dati."
        //         );
        //       }
        //     })
        //     .catch(() => {
        //       // Se c'è stato un errore fermo l'overlay di caricamento e stampo un avviso
        //       this.caricamento_dati = false;
        //       this.$refs.SnackbarQV.print(
        //         "error",
        //         "Errore di comunicazione col server, non è stato possibile caricare i dati."
        //       );
        //     });
        // },
        getAssociazioni() {
            var request = {
                controller: "Label",
                method: "POST",
                richiesta: {
                    action:
                        this.quicklabel_allowed == 1
                            ? "getpackaginglabel"
                            : "getpackagingreport",
                    token: localStorage.getItem("user_token"),
                    id_articolo_packaging:
                        this.contenitore_sel.id_articolo_packaging,
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.associazioni = res.data;
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        getMasterDetail(item) {
            return new Promise((resolve, reject) => {
                const request = {
                    controller: "Label",
                    method: "POST",
                    richiesta: {
                        action: "getmasterdetail",
                        token: localStorage.user_token,
                        id_label: item.id_label,
                    },
                };

                this.$store
                    .dispatch("api", request)
                    .then((res) => {
                        if (res.status === 200) {
                            this.label.base64 = res.data.report[0].modello;
                            this.label.modello = FrxToJson(this.label.base64);
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                `Criticità rilevata, codice stato: ${res.status}.`
                            );
                        }
                        resolve();
                    })
                    .catch((err) => {
                        this.$refs.SnackbarQV.print(
                            "error",
                            `${JSON.parse(err.response.data.message).result}.`
                        );
                        reject(err);
                    });
            });
        },
        getPackagingPartner() {
            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getpackagingpartner",
                    token: localStorage.user_token,
                    id_articolo_packaging:
                        this.contenitore_sel.id_articolo_packaging,
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        // Resetto l'array dei partner.
                        this.items_partner = new Array();

                        // Aggiungo gli oggetti che il BE mi ha restituito.
                        res.data.result.forEach((e) => {
                            this.items_partner.push(Object.assign({}, e));
                        });
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                    console.error(e);
                });
        },
        getTipologie() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "TIPOLOGIA_ETICHETTA_PACKAGING",
                    filter: "validita = 1",
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.items_tipologia = res.data ? res.data : [];
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        getTabelle() {
            this.caricamento_dati = true;

            // In order to get Contentore List
            let getTabelle = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "TIPOARTICOLO",
                    filter: "val_txt='PACK'",
                },
            };

            this.$store
                .dispatch("api", getTabelle)
                .then((res1) => {
                    this.caricamento_dati = false;

                    if (res1.status === 200) {
                        this.etichette_contenitori = res1.data ? res1.data : [];
                        this.etichette_contenitori.forEach((p) => {
                            if (p.val_int == 0) {
                                let imballoSearch = {
                                    controller: "Magazzino",
                                    method: "POST",
                                    richiesta: {
                                        action: "getarticoli",
                                        token: localStorage.getItem(
                                            "user_token"
                                        ),
                                        cod_articolo: "*",
                                        id_tipo: p.id_tabella,
                                    },
                                };

                                this.$store
                                    .dispatch("api", imballoSearch)
                                    .then((res2) => {
                                        if (res2.status === 200) {
                                            this.caricamento_dati = false;
                                            this.items_contenitori = Array.from(
                                                res2.data.lista
                                            );
                                        } else {
                                            this.caricamento_dati = false;
                                            this.$refs.SnackbarQV.print(
                                                "orange",
                                                "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                            );
                                        }
                                    })
                                    .catch(() => {
                                        this.caricamento_dati = false;
                                        this.$refs.SnackbarQV.print(
                                            "error",
                                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                        );
                                    });
                            } else if (p.val_int == 1) {
                                let imballoSearch = {
                                    controller: "Magazzino",
                                    method: "POST",
                                    richiesta: {
                                        action: "getarticoli",
                                        token: localStorage.getItem(
                                            "user_token"
                                        ),
                                        cod_articolo: "*",
                                        id_tipo: p.id_tabella,
                                    },
                                };
                                this.$store
                                    .dispatch("api", imballoSearch)
                                    .then((res3) => {
                                        if (res3.status === 200) {
                                            this.caricamento_dati = false;
                                            this.items_imballi = Array.from(
                                                res3.data.lista
                                            );
                                        } else {
                                            this.caricamento_dati = false;
                                            this.$refs.SnackbarQV.print(
                                                "orange",
                                                "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                            );
                                        }
                                    })
                                    .catch(() => {
                                        this.caricamento_dati = false;
                                        this.$refs.SnackbarQV.print(
                                            "error",
                                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                        );
                                    });
                            }
                        });
                    } else {
                        this.caricamento_dati = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        getReports() {
            /* Dato che è necessario differenziare la logica di business BE
             * per dare i dati delle etichette a seconda che il modulo QuickLabel
             * sia abilitato (estrae da t_label_master) o meno (estrae da
             * t_report) a seconda del valore del flag per l'abilitazione di
             * QuickLabel faccio due chiamate diverse (lo faccio segnando due
             * action diverse a seconda del caso). */
            var request = {
                controller: "Label",
                method: "POST",
                richiesta: {
                    action:
                        this.quicklabel_allowed == 0
                            ? "getreport"
                            : "getreportlabel",
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.items_labels = res.data;
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        goBack() {
            this.$emit("click_indietro");
        },
        goToDettaglioEichetta(item) {
            this.getMasterDetail(item);

            this.$nextTick(() => {
                this.key = this.key == 0 ? 1 : 0;
            });

            this.show_dettaglio_etichetta = true;

            // this.etichetta = FrxToJson(item.modello_report);
            // this.modello_originale = item.modello_report;
            // this.id_articolo_packaging_label = item.id_articolo_packaging_label;

            // this.show_dettaglio_etichetta = true;
            // this.key++;
        },
        modificaContenitore(arg) {
            this.key_gestione_pack = !this.key_gestione_pack;
            this.contenitore_sel = new Contenitore(arg);

            this.report_sel = this.contenitore_sel.id_label;

            /* Modifico gli input_args per fare in modo che i
             * dati consentano eventualmente all'utente di
             * visualizzare gli allegati del packaging. */
            this.input_args.id_riferimento =
                this.contenitore_sel.id_articolo_packaging;

            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticolidistintabase",
                    id_articolo: arg.id_articolo_imballo,
                    token: localStorage.user_token,
                },
            };

            this.caricamento_dati = true;
            /* Faccio una chiamata al BE per avere i dati
             * della distinta base della BOM imballo. */
            return this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.caricamento_dati = false;
                    if (res.status === 200) {
                        // Se la risposta è ok registro la BOM imballo
                        this.items_bom_imballo = Array.from(res.data);

                        // Faccio una seconda chiamata per avere la lista delle istruzioni
                        let getintro = {
                            controller: "Magazzino",
                            method: "POST",
                            richiesta: {
                                action: "getarticolipackagingistruzioni",
                                id_articolo_packaging:
                                    arg.id_articolo_packaging,
                                token: localStorage.getItem("user_token"),
                            },
                        };

                        this.caricamento_dati = true;
                        return this.$store
                            .dispatch("api", getintro)
                            .then((res2) => {
                                this.caricamento_dati = false;
                                if (res2.status === 200) {
                                    // Registro le istruzioni e apro la finestra di dialogo
                                    this.items_istruzioni = new Array();

                                    res2.data.forEach((r) => {
                                        const r_tmp = new Istruzione(r);
                                        this.items_istruzioni.push(
                                            Object.assign({}, r_tmp)
                                        );
                                    });

                                    this.setIndiceRicorsivo(
                                        this.items_istruzioni
                                    );
                                    this.getAssociazioni();

                                    this.modifica_contenitore = true;
                                    return true;
                                } else {
                                    this.$refs.SnackbarQV.print(
                                        "orange",
                                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                    );
                                    return false;
                                }
                            })
                            .catch(() => {
                                this.caricamento_dati = false;
                                this.$refs.SnackbarQV.print(
                                    "error",
                                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                );
                                return false;
                            });
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                        return false;
                    }
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                    return false;
                });
        },
        modificaIstruzione(arg) {
            this.istruzione_sel = new Istruzione(arg);
            this.modifica_istruzione_dialog = true;
        },
        printLabel(item) {
            this.etichetta_print = new Associazione(item);
            this.dialog_print = true;
        },
        setAssociazione(arg) {
            this.associazioni.forEach((a) => {
                if (a.editabile == true) {
                    a.editabile = 1;
                }
                if (a.editabile == false) {
                    a.editabile = 0;
                }
            });

            var request = {
                controller: "Label",
                method: "PUT",
                richiesta: {
                    action: "setpackaginglabel",
                    token: localStorage.getItem("user_token"),
                    packaging_label: this.associazioni,
                    modulo_ql: this.quicklabel_allowed,
                },
            };

            this.$store
                .dispatch("api", request)
                .then(async (res) => {
                    if (res.status === 200) {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Dati salvati correttamente."
                        );
                        this.show_associa_etichetta = false;
                        await this.fetchPackaging();
                        if (arg === 1) {
                            this.getAssociazioni();
                        }
                    }
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        GetEtichettaPDF(item) {
            this.loading = true;

            const request = {
                controller: "report",
                method: "POST",
                richiesta: {
                    action: "getreportpdf",
                    token: localStorage.user_token,
                    cod_report: item.cod_report,
                    parametri: [
                        {
                            parametro: "@id_articolo_packaging",
                            valore: item.id_articolo_packaging,
                        },
                    ],
                },
            };
            this.$store
                .dispatch("api", request)
                .then(async (res) => {
                    if (res.status === 200) {
                        if (
                            "tipo_messaggio" in res.data &&
                            "query_messaggio" in res.data &&
                            res.data.tipo_messaggio == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.query_messaggio
                            );
                        }
                        const byteCharacters = atob(res.data.result);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                            type: "application/pdf",
                        });
                        const blobUrl = URL.createObjectURL(blob);
                        this.selected_pdf = blobUrl;
                        this.loading = false;
                        this.pdfdialog = true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore visualizzazione anteprima"
                        );
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    if (
                        "tipo_messaggio" in err.response.data &&
                        "query_messaggio" in err.response.data &&
                        err.response.data.tipo_messaggio == 2
                    ) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            err.response.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore visualizzazione anteprima"
                        );
                    }
                });
        },
        goToPrinter() {
            var request = {
                controller: "Label",
                method: "PUT",
                richiesta: {
                    action: "setprintlabel",
                    token: localStorage.getItem("user_token"),
                    id_articolo_packaging_label:
                        this.etichetta_print.id_articolo_packaging_label,
                    quantita: this.qta_stampa,
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Dati salvati correttamente."
                        );
                        this.show_associa_etichetta = false;
                        this.fetchPackaging();
                    }
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile avviare la stampa."
                    );
                });
        },
        salvaContenitore() {
            // Eseguo dei check sui campi compilati
            /*if (
        this.contenitore_sel.id_articolo_imballo === null ||
        this.contenitore_sel.id_articolo_imballo === undefined ||
        this.contenitore_sel.id_articolo_imballo === ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Inserire una BOM Imballo per salvare."
        );
      }*/

            if (
                this.contenitore_sel.qta_contenitore === "" ||
                this.contenitore_sel.qta_contenitore === null ||
                this.contenitore_sel.qta_contenitore === undefined ||
                this.contenitore_sel.qta_contenitore <= 0
            ) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    "La quantità di prodotti per contenitore deve essere superiore a 0."
                );
                return;
            }

            /*if (
        this.contenitore_sel.qta_minima_spedizione === "" ||
        this.contenitore_sel.qta_minima_spedizione === null ||
        this.contenitore_sel.qta_minima_spedizione === undefined ||
        this.contenitore_sel.qta_minima_spedizione <= 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La quantità di prodotti per contenitore da spedire deve essere superiore a 0."
        );
        return;
      }*/

            // Modifico gli identificativi delle istruzioni nuove per comodità di BE
            this.items_istruzioni.forEach((i) => {
                if (i.id_pack_istruzioni < 0) {
                    i.id_pack_istruzioni = -1;
                }
            });

            // Se ci sono delle associazioni...
            if (this.associazioni.length > 0) {
                /* Controllo che non ci siano associazioni con la stessa tipologia
                 * facendomi un array temporaneo su cui inserisco parametri utili
                 * al controllo; se i controlli vanno bene procedo con la logica
                 * di salvataggio. */
                let chk_tipologia_ok = true;
                const arr_tmp = JSON.parse(JSON.stringify(this.associazioni));

                /* Assegno un indice a tutti gli oggetti delle associazioni,
                 * perché gli id potrebbero essere -1 per più righe nuove. */
                for (let i = 0; i < arr_tmp.length; i++) {
                    arr_tmp[i].idx = i;
                }

                arr_tmp.forEach((e) => {
                    arr_tmp.forEach((f) => {
                        if (e.idx != f.idx && e.tipologia == f.tipologia) {
                            chk_tipologia_ok = false;
                        }
                    });
                });

                if (chk_tipologia_ok === false) {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Non ci possono essere più etichette con la stessa tipologia per questo packaging."
                    );
                    return;
                }
            }

            // Mi faccio un oggetto temporaneo con i dati del contenitore da salvare
            const contenitore_tmp = new Contenitore(this.contenitore_sel);
            contenitore_tmp.id_articolo = this.data.id_articolo;

            const setPackaging = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setarticolopackaging",
                    token: localStorage.getItem("user_token"),
                    id_articolo: this.data.id_articolo,
                    articolo_packaging: [contenitore_tmp],
                    /* Il campo per le immagini era della vecchia gestione,
                     * ora sarà sempre vuoto perché usiamo gli allegati. */
                    articolo_packaging_immagini: [],
                    articolo_packaging_istruzioni: this.items_istruzioni.filter(
                        (e) => e.validita === 1 || e.id_pack_istruzioni > 0
                    ),
                },
            };

            this.caricamento_dati = true;
            this.$store
                .dispatch("api", setPackaging)
                .then((res) => {
                    if (res.status === 200) {
                        this.caricamento_dati = false;
                        /*if (this.$refs.componenteAllegati) {
              // Salvo gli eventuali allegati del contenitore.
              this.$refs.componenteAllegati.id_riferimento_creazione_genitore =
                res.data;
              this.$refs.componenteAllegati.salvaTuttiAllegati();
            }*/
                        if (this.associazioni.length != 0) {
                            this.setAssociazione();
                        }

                        this.fetchPackaging();

                        // Chiudo il dialog e resetto le debite variabili di supporto
                        this.modifica_contenitore = false;
                        this.tab_contenitore = new Array();
                        this.contenitore_sel = new Contenitore();
                        this.items_bom_imballo = new Array();
                        this.items_istruzioni = new Array();

                        /* Emetto un evento per segnalare che la finestra di dialogo è stata chiusa.
                         * Questa informazione è utile per quei componenti che montano questo
                         * file come componente figlio, perché ad esempio nell'Avanzamento Produzione
                         * significa che la procedura di SPACK è stata completata e bisogna eseguire
                         * una postquery. */
                        this.$emit("salvato_dettaglio_dialog");

                        // Stampo una snackbar di conferma.
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Contenitore aggiornato correttamente."
                        );
                    } else {
                        this.caricamento_dati = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile salvare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile salvare i dati."
                    );
                });
        },
        salvaIstruzione() {
            if (this.istruzione_sel.id_pack_istruzioni === -1) {
                this.istruzione_sel.id_pack_istruzioni = -moment().valueOf();
                this.items_istruzioni.push(
                    Object.assign({}, this.istruzione_sel)
                );
            } else {
                for (let i = 0; i < this.items_istruzioni.length; i++) {
                    if (
                        this.items_istruzioni[i].id_pack_istruzioni ===
                        this.istruzione_sel.id_pack_istruzioni
                    ) {
                        this.$set(
                            this.items_istruzioni,
                            i,
                            Object.assign({}, this.istruzione_sel)
                        );
                    }
                }
            }

            this.setIndiceRicorsivo(this.items_istruzioni);
            this.modifica_istruzione_dialog = false;
        },
        savePackaging() {
            /* Questo metodo serve a segnalare, dentro la commessa,
             * quale packaging di riferimento è stato scelto. */
            this.items_contenitori_alternativi.forEach((e) => {
                if (e.selected_for_commessa === 1) {
                    const obj_tmp = JSON.parse(JSON.stringify(e));
                    this.$emit("selezione_packaging", obj_tmp);
                }
            });
        },
        searchImballo() {
            let imballoSearch = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticoli",
                    token: localStorage.getItem("user_token"),
                    cod_articolo: this.cod_imballo,
                    id_tipo:
                        this.etichette_contenitori.filter(
                            (e) => e.val_int === 1
                        ).length > 0
                            ? this.etichette_contenitori.filter(
                                  (e) => e.val_int === 1
                              )[0].id_tabella
                            : null,
                },
            };

            this.caricamento_dati = true;

            this.$store
                .dispatch("api", imballoSearch)
                .then((res) => {
                    this.caricamento_dati = false;
                    if (res.status === 200) {
                        this.items_scelta_imballo = Array.from(res.data.lista);
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        searchRagSocC(arg_cod, arg_des) {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getragionesociale",
                    token: localStorage.getItem("user_token"),
                    cod_anagrafica: arg_cod,
                    des_anagrafica: arg_des,
                    tipo_anagrafica: "C",
                },
            };

            this.caricamento_dati = true;

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.caricamento_dati = false;
                    // Se la risposta è ok...
                    if (res.status === 200) {
                        // E contiene degli elementi...
                        if (res.data.length > 0) {
                            this.cod_anagrafica_search = "";
                            this.ragione_sociale_search = "";
                            this.is_anagrafica_fornitore = false;
                            this.dialog_ricerca_anagrafiche = true;
                            this.items_anagrafiche = Array.from(res.data);
                            this.items_anagrafiche_visualizzate = Array.from(
                                res.data
                            );
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Ragione Sociale non è stato trovato. Riprova !"
                            );
                        }
                    } else {
                        this.caricamento_dati = false;
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
            this.client = false;
        },
        searchRagSocF() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getragionesociale",
                    token: localStorage.getItem("user_token"),
                    cod_anagrafica: this.contenitore_sel.codice,
                    des_anagrafica: this.contenitore_sel.ragione_sociale,
                    tipo_anagrafica: "F",
                },
            };

            this.caricamento_dati = true;

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.caricamento_dati = false;
                    // Se la risposta è ok...
                    if (res.status === 200) {
                        // E contiene degli elementi...
                        if (res.data.length > 0) {
                            this.cod_anagrafica_search = "";
                            this.ragione_sociale_search = "";
                            this.is_anagrafica_fornitore = true;
                            this.dialog_ricerca_anagrafiche = true;
                            this.items_anagrafiche = Array.from(res.data);
                            this.items_anagrafiche_visualizzate = Array.from(
                                res.data
                            );
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Ragione Sociale non è stato trovato. Riprova !"
                            );
                        }
                    } else {
                        this.caricamento_dati = false;
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
            this.client = false;
        },
        selezionaAnagrafica(arg) {
            if (this.tab_contenitore == 3) {
                this.setPackagingPartner(arg);
            } else {
                // Assegno l'id_anagrafica al contenitore selezionato
                this.contenitore_sel.id_anagrafica = arg.id_anagrafica;

                // Se non è un fornitore, ne registro i dati come si deve
                if (this.is_anagrafica_fornitore === false) {
                    this.contenitore_sel.ragione_sociale_c =
                        arg.ragione_sociale;
                    this.contenitore_sel.ragione_sociale = "";
                    this.contenitore_sel.codice = arg.codice;
                } else {
                    // Se è un fornitore, ne registro i dati come si deve
                    this.contenitore_sel.ragione_sociale_c = "";
                    this.contenitore_sel.ragione_sociale = arg.ragione_sociale;
                    this.contenitore_sel.codice = arg.codice;
                }
            }

            // Resetto il modal di fornitore / cliente e chiudo il dialog
            this.is_anagrafica_fornitore = false;
            this.dialog_ricerca_anagrafiche = false;
        },
        selezionaImballo(arg) {
            this.contenitore_sel.id_articolo_imballo = arg.id_articolo;

            let getdistintabase = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticolidistintabase",
                    id_articolo: arg.id_articolo,
                    token: localStorage.getItem("user_token"),
                },
            };

            // Registro la distinta base nella BOM Imballo
            this.$store
                .dispatch("api", getdistintabase)
                .then((res) => {
                    if (res.status === 200 && res.data.length > 0) {
                        this.items_bom_imballo = _.cloneDeep(res.data);
                        this.contenitore_sel.des_imballo = res.data[0].name;

                        // Nascondo il dialog e ne resetto i dati
                        this.dialog_ricerca_imballi = false;
                        this.items_scelta_imballo = new Array();
                        this.cod_imballo = "";
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        setIndiceRicorsivo(array) {
            let indice = 0;

            for (let i = 0; i < array.length; i++) {
                if (array[i].validita === 1) {
                    indice = indice + 1;
                    array[i].indice = indice;
                }
            }
        },
        setContAltCommessa(arg) {
            for (
                let i = 0;
                i < this.items_contenitori_alternativi.length;
                i++
            ) {
                if (
                    this.items_contenitori_alternativi[i]
                        .id_articolo_packaging === arg.id_articolo_packaging
                ) {
                    this.$set(
                        this.items_contenitori_alternativi[i],
                        "selected_for_commessa",
                        this.items_contenitori_alternativi[i] === 1 ? 0 : 1
                    );
                } else {
                    this.$set(
                        this.items_contenitori_alternativi[i],
                        "selected_for_commessa",
                        0
                    );
                }
            }

            this.key_tabella = this.key_tabella === 0 ? 1 : 0;
        },
        setContAltStandard(arg, modalita) {
            if (modalita === "predefinito") {
                this.items_contenitori_alternativi.forEach((e) => {
                    if (e.id_articolo_packaging === arg.id_articolo_packaging) {
                        e.predefinito = e.predefinito === 1 ? 0 : 1;
                    } else {
                        e.predefinito = 0;
                    }
                });
            }

            if (modalita === "predefinito_per_cliente") {
                this.items_contenitori_alternativi.forEach((e) => {
                    if (
                        e.id_articolo_packaging === arg.id_articolo_packaging &&
                        e.id_anagrafica === arg.id_anagrafica
                    ) {
                        e.predefinito_per_cliente =
                            e.predefinito_per_cliente === 1 ? 0 : 1;
                    } else if (e.id_anagrafica === arg.id_anagrafica) {
                        e.predefinito_per_cliente = 0;
                    }
                });
            }

            // Mando una chiamata al BE per registrare la variazione
            const request = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setcontenitorialternativi",
                    token: localStorage.user_token,
                    tabella: this.items_contenitori_alternativi,
                },
            };

            this.caricamento_dati = true;
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.caricamento_dati = false;
                    if (res.status === 200) {
                        // Quando il BE mi dice di aver aggiornato i dati, li ricarico
                        this.fetchPackaging();
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile salvare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile salvare i dati."
                    );
                });
        },
        // setPackagingPartner(arg) {
        //   /* Controllo che il packaging non sia nuovo perché non
        //    * posso associare partner a un elemento che non è ancora
        //    * stato salvato sul DB e manca di chiave primaria. */
        //   if (this.contenitore_sel.id_articolo_packaging == -1) {
        //     this.$refs.SnackbarQV.print(
        //       "error",
        //       "Errore tecnico, non è possibile salvare i dati."
        //     );
        //     return;
        //   }

        //   // Se il controllo è superato, procedo al salvataggio.
        //   const obj_tmp = Object.assign({}, arg);
        //   obj_tmp.id_articolo_packaging =
        //     this.contenitore_sel.id_articolo_packaging;

        //   const request = {
        //     controller: "Magazzino",
        //     method: "PUT",
        //     richiesta: {
        //       action: "setpackagingpartner",
        //       token: localStorage.user_token,
        //       partner: [obj_tmp],
        //     },
        //   };

        //   this.$store
        //     .dispatch("api", request)
        //     .then((res) => {
        //       if (res.status === 200) {
        //         this.getPackagingPartner();
        //       } else {
        //         this.$refs.SnackbarQV.print(
        //           "orange",
        //           "Errore di comunicazione col server, non è stato possibile caricare i dati."
        //         );
        //       }
        //     })
        //     .catch((e) => {
        //       this.$refs.SnackbarQV.print(
        //         "error",
        //         "Errore di comunicazione col server, non è stato possibile caricare i dati."
        //       );
        //       console.error(e);
        //     });
        // },
        snackbarOpen() {
            //funzione triggerata per cogliere l'errore degli allegati che non hanno la descrizione inserita
            this.$refs.SnackbarQV.print(
                "orange",
                "Aggiungere ad ogni Allegato dell'attività una descrizione."
            );
        },
    },
    created() {},
    mounted() {
        /* Se l'id_articolo di "data" (che sarebbe il mio articolo)
         * è null vuol dire che probabilmente sto usando questo componente
         * come sotto-somcponente di un componente più grande, in cui lo
         * uso solo per il dialog di modifica del packaging. Tipicamente
         * in questo caso non voglio che carichi i packaging alternativi,
         * sarò io a passare dal padre i dettagli sul suo flusso operativo
         * usando le refs. Le altre chiamate di inizializzaizone non creano
         * problemi e possono essere fatte. */
        if (this.data.id_articolo != null) {
            this.fetchPackaging();
        }
        // this.getAnagrafica();

        this.getTabelle();
        this.getTipologie();
        // this.getAssociazioni();

        /* Filtro gli header in base all'abilitazione o meno
         * di QuickLabel dato che se QuickLabel non è abilitato
         * il Dettaglio non si può vedere niente. */
        if (this.quicklabel_allowed === 0) {
            const arr_tmp = new Array();

            this.headers_associazioni.forEach((e) => {
                if (e.text != "Dettaglio") {
                    arr_tmp.push(Object.assign({}, e));
                }
            });

            this.headers_associazioni = new Array();
            arr_tmp.forEach((e) => {
                this.headers_associazioni.push(Object.assign({}, e));
            });
        }
    },
};
</script>
<style scoped></style>
